<div class="zwi-title" [class]="{'zwi-title--offset': offset}">
  <ng-content></ng-content>
</div>
